import { CampaignConfig } from '@galaxy/campaign/dependencies';
import { InjectionToken } from '@angular/core';

export type CONFIG_TYPE = CampaignConfig;
export const CONFIG_TOKEN = new InjectionToken('com.vendasta.campaigns.config');
